import React, { FC } from 'react';
import { Body, Button, Card, Heading, TrevorIcon } from '@trevor/ui-components';
import styled from 'styled-components';
import { IntercomAPI } from '@/integrations/Intercom';
import { userAction } from '@/util/helpers/ajax-helpers';
import { useGetDatasourcesQuery } from '@/features/datasources/apiSlice';

const instructionList: string[] = [
  'Create a Trevor.io account',
  'Connect your datasource',
  'Add you as a collaborator',
];

const OptionsContainer = styled.div`
  display: flex;
  gap: var(--spacing-s);
  justify-content: center;
`;

const InstructionListContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: var(--spacing-s);
  justify-content: space-evenly;

  > p {
    font-weight: 500;
    line-height: 40px;
  }
`;

const HeaderContainer = styled.div`
  text-align: center;

  > p {
    margin-top: 21px;
  }
`;

const InstructionList = () => (
  <InstructionListContainer>
    {instructionList.map((instruction, index) => (
      <Body key={instruction} variant={1}>
        {index + 1}. {instruction}
      </Body>
    ))}
  </InstructionListContainer>
);

type AskDatabaseOwnerStepProps = {
  onConnectSampleDatabase: F0;
};
export const AskDatabaseOwnerStep: FC<AskDatabaseOwnerStepProps> = ({
  onConnectSampleDatabase,
}) => {
  const { data } = useGetDatasourcesQuery();
  const hasDatasources = Boolean(data?.datasources.length);

  const handleLiveSupport = () => {
    userAction('live-chat-support-clicked', {
      section: 'step-2-ask-your-database-owner',
    });
    IntercomAPI.show();
  };

  const handleConnectSampleDatabase = () => {
    userAction('connect-sample-datasource-clicked', {
      section: 'step-2-ask-your-database-owner',
    });
    onConnectSampleDatabase();
  };

  return (
    <Card width="100%" padding={32} gap={32} alignItems="center">
      <HeaderContainer>
        <Heading variant={4}>Step 2: Ask your database owner</Heading>
        <Body variant={1}>
          Just ask your database owner (typically your CTO or Lead Engineer) to:
        </Body>
      </HeaderContainer>
      <InstructionList />
      {!hasDatasources && (
        <Body variant={1}>
          If they'd like to test Trevor first, you can invite them to a sample
          database.
        </Body>
      )}
      <OptionsContainer>
        <Button
          size="large"
          variant="secondary"
          icon={<TrevorIcon name="web" />}
          onClick={handleLiveSupport}
        >
          Live chat support
        </Button>
        {!hasDatasources && (
          <Button
            size="large"
            variant="secondary"
            icon={<TrevorIcon name="rocket" />}
            onClick={handleConnectSampleDatabase}
          >
            Explore sample database
          </Button>
        )}
      </OptionsContainer>
    </Card>
  );
};
